import { Injectable, ErrorHandler } from '@angular/core';
import { AlertController } from "@ionic/angular";
import { ConfigService } from "./config.service";
import { LanguageService } from '../language/language.service';
// import * as Sentry from "@sentry/browser";

@Injectable({
    providedIn: 'root'
})
export class ErrorHandlerService implements ErrorHandler {
    private alert: any;

    constructor(
        private config: ConfigService,
        private alertCtrl: AlertController,
        private langService: LanguageService,
    ) { }

    public logError(error: Error): void {
        if (this.config.get("production")) {
            // Sentry.captureException(error);
        }
    }

    public logInfo(data: any): void {
        if (this.config.get("production")) {
            // Sentry.captureMessage(data);
        }
    }

    public async create(err: any = {}): Promise<any> {
        const alert = await this.alertCtrl.create({
            header: await this.langService.translate("An error occurred") || "An error occurred",
            subHeader: err.message || "",
            message: await this.langService.translate(err.code ? "Error code: " + err.code : ""),
            cssClass: "lem-error-alert",
            backdropDismiss: true,
            buttons: [{
                text: await this.langService.translate("Close") || "Close",
                role: "cancel",
            }],
        });
        await alert.present();

        return alert;
    }

    public async handleError(error: Error) {
        console.error("Error Handler Service:", error);
        this.logError(error);
        if (this.alert) {
            console.info("already alert present");
            return;
        }

        this.alert = this.create({
            message: await this.langService.translate("If the issue continues, please contact support.") || "If the issue continues, please contact support.",
            code: this.config.get("server.error_codes.ui") || this.config.get("error_codes.ui") || "local",
        }).then(async (alert) => {
            await alert.onDidDismiss()
            this.alert = null;
        }).catch(alert => {
            this.alert = null;
        });
    }
}
